import { LoadingIndicator, Table } from "@light-technology/components";
import { format } from "date-fns";
import type { WebhookEvent } from "../../state/api.types";

type WebhookSlideoutEventsProps = {
  events: WebhookEvent[];
  isFetching: boolean;
};

export const WebhookSlideoutEvents = ({
  events,
  isFetching,
}: WebhookSlideoutEventsProps) => {
  if (isFetching) {
    return <LoadingIndicator type="brand-spinner" />;
  }

  if (!events.length) {
    return <div className="text-sm text-tertiary">No events</div>;
  }

  return (
    <Table aria-label="Events">
      <Table.Header sticky stickyClassName="bg-primary">
        <Table.Head isRowHeader id="event" label="Event" />
        <Table.Head id="status" label="Status" />
        <Table.Head id="created" label="Created" />
      </Table.Header>
      <Table.Body>
        {events.map((event) => (
          <Table.Row key={event.uuid}>
            <Table.Cell>{event.type}</Table.Cell>
            <Table.Cell>{event.successful_at ? "Success" : "Error"}</Table.Cell>
            <Table.Cell>{format(event.created_at, "Pp")}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};
